import { Button, Grid, Box, Stack, Typography } from "@mui/material";
import { Container } from "@mui/system";
import { useEffect, useMemo, useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import InputForm from "../../components/molecules/forms/inputForm";
import type { RootState } from "../../store";
import { useForm } from "react-hook-form";
import { useAppDispatch, useAppSelector } from "../../store";
import { yupResolver } from "@hookform/resolvers/yup";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import LoginSchema from "../../utils/validation/login";
import { useNavigate } from "react-router-dom";
import { setToken } from "../../utils/storage";
import {
  useConfirmPasswordMutation,
  useSubmitLoginMutation,
} from "../../store/feature/service/userApiSlice";
import Swal from "sweetalert2";
import {
  MailOutline as MailOutlineIcon,
  Lock as LockIcon,
} from "@mui/icons-material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import indonesiaImg from "../../assets/logo/Indonesia.png";
import autentikaImg from "../../assets/logo/medium.png";
import entrustLogo from "../../assets/logo/entrustWhite.png";
import { useGetUserAccRoleMutation } from "../../store/feature/service/UserAccountApiSlice";
import { encrypt } from "../../utils/hash/password";

const Login = () => {
  const navigate = useNavigate();
  const [emailUser, setEmailUser] = useState("");
  const [isShowPass, setIsShowPass] = useState(false);
  const [isShowConfirmPass, setIsShowConfirmPass] = useState(false);
  const [isShowNewPass, setIsShowNewPass] = useState(false);
  const [isChangePassword, setIsChangePassword] = useState(false); // toggle to show change password
  const [
    submitLogin,
    { error: errorLogin, isLoading, isError, isSuccess, data: successData },
  ] = useSubmitLoginMutation();
  const [
    confirmPassword,
    {
      error: errorDataConfirmPass,
      isError: errorConfirmPass,
      isSuccess: successConfirmPass,
    },
  ] = useConfirmPasswordMutation();
  const [GetUserAccRole, { data: dataRole }] = useGetUserAccRoleMutation();
  const { accesToken } = useAppSelector((state: RootState) => state.user);

  interface ILogin {
    Email: string;
    email: string;
    password: string;
    Password: string;
    showPass: boolean;
    newPassword: string;
    confirmNewPassword: string;
  }

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<ILogin>({
    reValidateMode: "onChange",
    resolver: yupResolver(LoginSchema),
    defaultValues: {
      email: "",
      password: "",
      showPass: false,
    },
  });

  const onSubmit = async (data: ILogin) => {
    if (!isChangePassword) {
      submitLogin(data);
      setEmailUser(data?.Email);
      console.log("data here ===> ", data);
    } else {
      confirmPassword(data);
      setEmailUser(data?.Email);
      console.log("data here ===> ", data);
    }
  };

  useEffect(() => {
    if (isSuccess) {
      console.log("success login");
      localStorage.setItem("Email", emailUser);
      GetUserAccRole({});
    }
  }, [isSuccess]);

  const endAdornment = useMemo(() => {
    if (isShowPass) {
      return <VisibilityIcon />;
    }
    return <VisibilityOffIcon />;
  }, [isShowPass]);

  const endAdornmentConfirm = useMemo(() => {
    if (isShowConfirmPass) {
      return <VisibilityIcon />;
    }
    return <VisibilityOffIcon />;
  }, [isShowConfirmPass]);

  const endAdornmentNewPass = useMemo(() => {
    if (isShowNewPass) {
      return <VisibilityIcon />;
    }
    return <VisibilityOffIcon />;
  }, [isShowNewPass]);

  const toggleShowPassword = () => {
    setIsShowPass((prev) => !prev);
  };

  const toggleShowPasswordConfirm = () => {
    setIsShowConfirmPass((prev) => !prev);
  };

  const toggleShowNewPassword = () => {
    setIsShowNewPass((prev) => !prev);
  };

  useEffect(() => {
    if (isError) {
      const dataError: any = errorLogin;
      if (dataError?.data?.message === "password_change_required") {
        Swal.fire({
          icon: "info",
          title: "Change Password Notification",
          showCancelButton: false,
          confirmButtonText: "Change Password",
          confirmButtonColor: "#051438",
          text: `Password change required. Please enter your new password on the next screen`,
          didOpen: () => setIsChangePassword(true),
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error Login",
          showCancelButton: false,
          confirmButtonText: "OK",
          confirmButtonColor: "#051438",
          text: "Please Check Your Email and Password",
        });
      }
    }
  }, [isError]);

  useEffect(() => {
    if (successConfirmPass) {
      Swal.fire({
        icon: "success",
        title: "Success Create ",
        showCancelButton: false,
        confirmButtonText: "OK",
        confirmButtonColor: "#051438",
        text: "Success Create New Password",
        didOpen: () => setIsChangePassword(false),
      });
    }
  }, [successConfirmPass]);

  useEffect(() => {
    if (errorConfirmPass) {
      Swal.fire({
        icon: "error",
        title: "Error Create",
        showCancelButton: false,
        confirmButtonText: "OK",
        confirmButtonColor: "#051438",
        text: "Error Create New Password",
        didOpen: () => setIsChangePassword(true),
      });
    }
  }, [errorConfirmPass]);

  useEffect(() => {
    if (accesToken) {
      setToken(accesToken);
      navigate("/", { replace: true });
    }
  }, [accesToken]);

  const theme = createTheme({
    palette: {
      primary: {
        main: "#051438", // Change this to your desired color
      },
    },
  });

  return (
    <div
      style={{
        backgroundImage: `url(${indonesiaImg})`,
        backgroundSize: "cover",
        backgroundColor: "#051438",
        height: "auto",
        maxWidth: "100%",
      }}
    >
      <Container maxWidth="sm">
        <Grid
          container
          spacing={2}
          direction="column"
          justifyContent="center"
          alignItems="center"
          sx={{
            minHeight: "105vh",
            marginLeft: "auto",
            marginRight: "auto",
            width: "100%",
          }}
        >
          <Stack
            style={{
              display: "grid",
              placeItems: "center", // Centers both horizontally and vertically
            }}
          >
            <Box
              bgcolor="#FFFFFF"
              borderRadius={"50%"}
              boxShadow={3}
              width={"100px"}
              height={"100px"}
              textAlign="center"
              marginBottom={"-50px"}
              zIndex={1000}
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
            >
              <img src={autentikaImg} height={"75px"} width={"75px"} />
            </Box>
            <Box
              pt={9}
              pb={2}
              pl={5}
              pr={5}
              bgcolor="#FFFFFF"
              borderRadius={4}
              boxShadow={3}
              maxWidth="500px"
              width="100%"
              textAlign="center"
            >
              <Grid
                container
                direction="column"
                component="form"
                onSubmit={handleSubmit(onSubmit)}
              >
                <Grid item>
                  <Typography
                    variant="h5"
                    sx={{ fontWeight: "bold", marginBottom: "1rem" }}
                  >
                    {isChangePassword
                      ? "Change Password "
                      : "Welcome to DigSig"}
                  </Typography>
                </Grid>
                <Grid item>
                  <InputForm
                    name="Email"
                    errors={errors}
                    control={control}
                    required
                    placeholder="Username / Email"
                    maxLength={100}
                    isLoading={false}
                    sxEndAdornment={{
                      backgroundColor: "inherit",
                      border: "none",
                      cursor: "pointer",
                      width: "4rem",
                    }}
                    showStartAdornment
                    startAdornment={<MailOutlineIcon />}
                    sxFC={{ marginBottom: "1rem" }}
                  />
                </Grid>
                <Grid item>
                  <InputForm
                    name="Password"
                    errors={errors}
                    control={control}
                    type={isShowPass ? "text" : "password"}
                    placeholder="Password"
                    maxLength={127}
                    showEndAdornment
                    sxEndAdornment={{
                      backgroundColor: "inherit",
                      border: "none",
                      cursor: "pointer",
                      width: "4rem",
                    }}
                    endAdornment={endAdornment}
                    onClickEndAdornment={toggleShowPassword}
                    required
                    showStartAdornment
                    startAdornment={<LockIcon />}
                    sxFC={{ marginBottom: "1.5rem" }}
                  />
                </Grid>
                {isChangePassword && (
                  <>
                    <Grid item>
                      <InputForm
                        name="newPassword"
                        errors={errors}
                        control={control}
                        type={isShowNewPass ? "text" : "password"}
                        placeholder="New Password"
                        maxLength={127}
                        showEndAdornment
                        sxEndAdornment={{
                          backgroundColor: "inherit",
                          border: "none",
                          cursor: "pointer",
                          width: "4rem",
                        }}
                        endAdornment={endAdornmentNewPass}
                        onClickEndAdornment={toggleShowNewPassword}
                        required
                        showStartAdornment
                        startAdornment={<LockIcon />}
                        sxFC={{ marginBottom: "1.5rem" }}
                      />
                    </Grid>
                    <Grid item>
                      <InputForm
                        name="confirmNewPassword"
                        errors={errors}
                        control={control}
                        type={isShowConfirmPass ? "text" : "password"}
                        placeholder="Confirm New Password"
                        maxLength={127}
                        showEndAdornment
                        sxEndAdornment={{
                          backgroundColor: "inherit",
                          border: "none",
                          cursor: "pointer",
                          width: "4rem",
                        }}
                        endAdornment={endAdornmentConfirm}
                        onClickEndAdornment={toggleShowPasswordConfirm}
                        required
                        showStartAdornment
                        startAdornment={<LockIcon />}
                        sxFC={{ marginBottom: "1.5rem" }}
                      />
                    </Grid>
                  </>
                )}
                <Grid item>
                  {isLoading ? (
                    <ThemeProvider theme={theme}>
                      <LoadingButton
                        loading
                        loadingPosition="start"
                        startIcon={<SaveIcon />}
                        variant="outlined"
                        fullWidth
                        color="secondary"
                        sx={{ borderRadius: "12px", textTransform: "none" }}
                      >
                        {isChangePassword ? "Submit" : "Login"}
                      </LoadingButton>
                    </ThemeProvider>
                  ) : (
                    <ThemeProvider theme={theme}>
                      <>
                        <Button
                          type="submit"
                          fullWidth
                          variant="contained"
                          sx={{ borderRadius: "12px", textTransform: "none" }}
                        >
                          {isChangePassword ? "Submit" : "Login"}
                        </Button>
                        {/* <PopUpTab /> */}
                      </>
                    </ThemeProvider>
                  )}
                </Grid>
                <Grid item sx={{ marginTop: "20px" }}>
                  <img src={entrustLogo} height={"50px"} width={"180px"} />
                </Grid>
              </Grid>
            </Box>
          </Stack>
        </Grid>
      </Container>
    </div>
  );
};

export default Login;
